import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { message } from 'antd';

const getAccessToken = () => localStorage.getItem('access_token') || '';

const initialState = {
  curator: '',
  allCurators: [],
  loading: false,
  error: null,
};

export const fetchCurators = createAsyncThunk(
  'curatorSlice/fetchCurators',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URI}/curatorCampaign/all`, {
        headers: {
          authorization: getAccessToken(),
        },
      });

      const curatorData = Array.isArray(response.data)
        ? response.data
        : response.data.data && Array.isArray(response.data.data)
          ? response.data.data
          : [];

      const uniqueCurators = [];
      const valueSet = new Set();

      curatorData.forEach(curator => {
        if (!valueSet.has(curator.value)) {
          valueSet.add(curator.value);
          uniqueCurators.push(curator);
        }
      });

      return uniqueCurators;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to fetch curators');
    }
  }
);

export const getProfile = createAsyncThunk('completeProfileSlice/getProfile', async () => null);

export const curatorSlice = createSlice({
  name: 'curatorSlice',
  initialState,
  reducers: {
    addCurator: (state, action) => {
      try {
        let data = JSON.stringify(action.payload.data);
        let config = {
          method: 'post',
          maxBodyLength: Infinity,
          url: `${process.env.REACT_APP_BACKEND_URI}/curatorCampaign/createCurator`,
          headers: {
            'Content-Type': 'application/json',
          },
          data: data,
        };

        axios
          .request(config)
          .then(() => {
            action.payload.callback();
            message.success(
              'Thank you! Your details have been submitted and we will contact you as soon as possible.'
            );
          })
          .catch(error => {
            const errorValues = Object.values(error?.response?.data?.error?.errors || {});
            let errorMsg =
              errorValues.length === 1
                ? errorValues[0]?.message
                : 'fill all fields with valid data';
            message.error(errorMsg);
          });
      } catch (err) {
        message.error('Failed to submit curator details. Please try again.');
      }
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getProfile.pending, (state, action) => {})
      .addCase(getProfile.fulfilled, (state, action) => {
        state.userProfile = action.payload;
      })
      .addCase(getProfile.rejected, (state, action) => {})
      .addCase(fetchCurators.pending, (state, action) => {
        if (!action.meta.arg?.silent) {
          state.loading = true;
        }
        state.error = null;
      })
      .addCase(fetchCurators.fulfilled, (state, action) => {
        state.loading = false;
        state.allCurators = action.payload || [];
      })
      .addCase(fetchCurators.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export const { addCurator } = curatorSlice.actions;

export default curatorSlice.reducer;
